var React = require('react');

function Hide (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M 17.879 8.064 C 11.514 8.064 6.08 12.025 3.879 17.61 C 6.08 23.198 11.514 27.156 17.879 27.156 C 24.244 27.156 29.678 23.198 31.879 17.61 C 29.678 12.025 24.244 8.064 17.879 8.064 Z M 17.879 23.975 C 14.366 23.975 11.514 21.125 11.514 17.61 C 11.514 14.098 14.366 11.247 17.879 11.247 C 21.392 11.247 24.244 14.098 24.244 17.61 C 24.244 21.125 21.392 23.975 17.879 23.975 Z M 17.879 13.791 C 15.766 13.791 14.06 15.498 14.06 17.61 C 14.06 19.725 15.766 21.429 17.879 21.429 C 19.992 21.429 21.698 19.725 21.698 17.61 C 21.698 15.498 19.992 13.791 17.879 13.791 Z","fill":"#858585","key":0}),React.createElement("line",{"x1":"7.57","y1":"7.101","x2":"30.753","y2":"30.282","stroke":"#858585","strokeWidth":"2","key":1})]);
}

Hide.defaultProps = {"width":"39","height":"39","viewBox":"0 0 39 39","fill":"none"};

module.exports = Hide;

Hide.default = Hide;
